import { makeStyles } from '@material-ui/core';

export const useSubHeaderStyles = makeStyles((theme) => ({
  box: (props) => ({
    backgroundImage: props.backgroundImage
      ? `url(${props.backgroundImage})`
      : 'none',
    height: props.height ? props.height : '92px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: props.padding ? props.padding : '0 20px',
  }),
}));
